






export const fullNameValidator = (data) => {
  const onlyLetters = /^[A-Za-z\s]+$/;

  if (!data.trim()) {
    return "Full Name is required";
  }
  else if (data.length < 3) {
    return "Full Name must be at least 3 characters";
  }
  else if (!onlyLetters.test(data)) {
    return "Full Name should contain only letters and spaces";
  }

  return null;
};


// ================= EMAIL VALIDATOR =================
export const emailValidator = (inputEmail) => {
  const emailErrors = [];

  if (!inputEmail || !inputEmail.trim()) {
    emailErrors.push("Email is required.");
  } else {
    // Updated regex: At least 2 characters before @, 2 after @, 2 after last dot
    const emailRegex = /^[^\s@]{2,}@[^\s@]{2,}\.[^\s@]{2,}$/;
    if (!emailRegex.test(inputEmail)) {
      emailErrors.push("Enter a valid email address (minimum 2 characters before and after '@' and '.' required).");
    }
  }

  return emailErrors.join(" ");
};


// ================= CONTACT VALIDATOR =================
export const contactValidator = (data) => {
  if (!data) return "Contact is required.";

  if (!/^[6-9]\d{9}$/.test(data)) {
    return "Contact number must be 10 digits and start with 6–9";
  }

  return "";
};


// ================= PASSWORD VALIDATOR =================
export const passwordValidator = (inputPassword) => {
  if (!inputPassword || !inputPassword.trim()) {
    return "Password is required.";
  }

  const passwordRegex = {
    length: /.{8,}/,
    upper: /[A-Z]/,
    lower: /[a-z]/,
    number: /[0-9]/,
    special: /[@$!%*#?&.]/,
  };

  if (!passwordRegex.length.test(inputPassword))
    return "Minimum 8 characters required.";

  if (!passwordRegex.upper.test(inputPassword))
    return "At least 1 uppercase letter required.";

  if (!passwordRegex.lower.test(inputPassword))
    return "At least 1 lowercase letter required.";

  if (!passwordRegex.number.test(inputPassword))
    return "At least 1 number required.";

  if (!passwordRegex.special.test(inputPassword))
    return "At least 1 special character required.";

  return "";
};


// ================= SINGLE FIELD VALIDATION =================
export const validateField = (name, value, form, schema) => {
  const rules = schema[name];
  if (!rules) return "";

  // Required
  if (rules.required && !value) {
    return "This field is required";
  }

  // Custom field validators
  switch (name) {
    case "fullname":
      return fullNameValidator(value);
    case "email":
      return emailValidator(value);

    case "contact":
      return contactValidator(value);

    case "password":
      return passwordValidator(value);

    case "confirmPassword":
      if (!value) return "Confirm password is required";
      if (value !== form.password)
        return "Passwords do not match";
      return "";

    default:
      return "";
  }
};


// ================= FULL FORM VALIDATION =================
export const validateForm = (form, schema) => {
  const errors = {};

  for (const field in schema) {
    const error = validateField(field, form[field], form, schema);
    if (error) {
      errors[field] = error;
    }
  }

  return errors;
};


// ================= SCHEMA =================
export const validationSchema = {
  register: {
    fullname: { required: true },
    email: { required: true },
    contact: { required: true },
    password: { required: true },
    confirmPassword: { required: true },
  },
};


export const loginValidation = {
  email: {
    required: true,
    pattern: /^\S+@\S+\.\S+$/,
    message: "Enter a valid email address",
  },
  password: {
    required: true,
    minLength: 6,
    message: "Password must be at least 6 characters",
  },
};

